import React from 'react';
import './FormationChangeDialog.css';

interface FormationChangeDialogProps {
  isOpen: boolean;
  newFormationName: string;
  onKeepPlayers: () => void;
  onStartNew: () => void;
  onCancel: () => void;
}

const FormationChangeDialog: React.FC<FormationChangeDialogProps> = ({
  isOpen,
  newFormationName,
  onKeepPlayers,
  onStartNew,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="formation-dialog-overlay">
      <div className="formation-dialog">
        <div className="formation-dialog-header">
          <h3>Change Formation</h3>
        </div>
        <div className="formation-dialog-content">
          <p>You're changing to <strong>{newFormationName}</strong>.</p>
          <p>Do you want to try keeping your current players in the new formation or start with a clean team?</p>
        </div>
        <div className="formation-dialog-actions">
          <button 
            className="formation-dialog-button keep-button"
            onClick={onKeepPlayers}
          >
            Keep Players
            <span className="button-description">Attempt to map current players to new positions</span>
          </button>
          <button 
            className="formation-dialog-button new-button"
            onClick={onStartNew}
          >
            Start New
            <span className="button-description">Remove all players and start fresh</span>
          </button>
          <button 
            className="formation-dialog-button cancel-button"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default FormationChangeDialog; 